import { useInfiniteQuery } from '@tanstack/react-query'
import { userHostTaskSpecialService } from '../../../../services/users-tasks/users-hosts-tasks-specials'
import type { GetList } from '../../../../services/users-tasks/users-hosts-tasks-specials/types'

export const USERS_HOSTS_TASKS_SPECIALS_QUERY_KEY = 'getUsersHostsTasksSpecials'

export const useGetUsersHostsTasksSpecials = (params: GetList.Input) => {
  const { data, isFetchingNextPage, isLoading, refetch, fetchNextPage } =
    useInfiniteQuery({
      queryKey: [USERS_HOSTS_TASKS_SPECIALS_QUERY_KEY, params],
      initialPageParam: 0,
      queryFn: ({ pageParam: skip }) => {
        return userHostTaskSpecialService.getList({ take: 20, skip, ...params })
      },
      getNextPageParam: (lastPage, _allPages, lastPageParam) => {
        if (lastPage?.error) return null

        if (lastPage && !lastPage?.data?.length) return null

        return lastPageParam + 1
      },
    })

  return {
    usersHostsTasksSpecials: data?.pages?.flatMap((page) => page?.data),
    isFetchingNextPage,
    isLoading,
    nextPage: fetchNextPage,
    refetch,
  }
}
